import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  path,
} from 'ramda';
import {
  fetchQuoteById,
  getPdfFileForQuote,
  getPreView, updateQuoteStatus,
} from '../../api/quotes';
import '../../css/forms/default-forms.css';
import './style.css';
import QuoteModalForm from '../QuoteModalForm';
import moment from "moment";

export class QuotePreView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showApproveModal: false,
      showRejectModal: false,
    };

    this.fetchDataRouteById = this.fetchDataRouteById.bind(this);
    this.close = this.close.bind(this);
    this.print = this.print.bind(this);
    this.toggleRejectModal = this.toggleRejectModal.bind(this);
    this.toggleApproveModal = this.toggleApproveModal.bind(this);
  }

  componentWillMount() {
    this.fetchDataRouteById();
  }

  fetchDataRouteById() {
    const id = path(['match', 'params', 'id'], this.props);

    this.props.getPreViewHtml(id);
    this.props.getDataById(id);
  }

  close() {
    this.props.backToDashboard();
  }

  toggleApproveModal() {
    this.setState({
      showApproveModal: !this.state.showApproveModal,
    });
  }

  toggleRejectModal() {
    this.setState({
      showRejectModal: !this.state.showRejectModal,
    });
  }

  print() {
    const id = path(['match', 'params', 'id'], this.props);

    this.props.getPdf(id);
  }

  renderButton() {
    return (
      <div className="col-12 button-area">
        <div className="float-right">
          <button className="btn btn-info btn-outline" type='button' onClick={this.print}>
            <i className="fa fa-file-pdf-o"></i>
            <span>PDF</span>
          </button>
          <button className="btn btn-success btn-outline" type='button' onClick={this.toggleApproveModal}>
            <i className="fa fa-check"></i>
            <span>Approve</span>
          </button>
          <button className="btn btn-danger btn-outline" type='button' onClick={this.toggleRejectModal}>
            <i className="fa fa-remove"></i>
            <span>Reject</span>
          </button>
        </div>
      </div>
    );
  }

  renderStatus(type, statusChangedDate) {
    const correctType = type === 'approved' ? 'Approved' : 'Rejected';
    return (
      <div className={`status-area ${type}`}>
        <div className="left-area">
          <i className="fa fa-check-circle-o"/>
          {correctType}
        </div>
        <div className="right-area">{correctType} on {statusChangedDate}</div>
      </div>
    );
  }

  render() {
    const id = path(['match', 'params', 'id'], this.props);
    const quote = path(['quotes', 'quote', 'quote'], this.props);
    let currentStatus = path(['status'], quote);
    currentStatus = (currentStatus === 'approved_by_customer' || currentStatus === 'approved') ? 'approved' : currentStatus;
    let statusChangedDate = path(['status_changed_date'], quote);
    if (statusChangedDate) {
      statusChangedDate = moment(statusChangedDate).format('MM/DD/YYYY HH:mm')
    }
    const showButton = currentStatus !== 'approved' && currentStatus !== 'declined';
    const taskPreVire = path(['quotes', 'html'], this.props);

    return (
      <div style={{ padding: '0 30px' }}>
        <div className='content'>
          {!showButton && currentStatus && this.renderStatus(currentStatus, statusChangedDate)}
          {showButton && this.renderButton()}
          <div dangerouslySetInnerHTML={{ __html: taskPreVire }}></div>
        </div>
        <QuoteModalForm
          buttonsText={["Approve"]}
          type='Approved by customer'
          isShow={this.state.showApproveModal}
          toggleFunc={this.toggleApproveModal}
          icon='fa-smile-o'
          color='success'
          updateQuoteStatus={this.props.updateQuoteStatus(id)}
        />
        <QuoteModalForm
          type='Reject'
          isShow={this.state.showRejectModal}
          toggleFunc={this.toggleRejectModal}
          icon='fa-frown-o'
          color='danger'
          updateQuoteStatus={this.props.updateQuoteStatus(id)}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDataById: (id) => {
      fetchQuoteById(id)(dispatch);
    },
    getPreViewHtml: (id) => {
      getPreView(id)(dispatch);
    },
    backToDashboard: () => {
      dispatch(push('/pages/dashboards'));
    },
    updateQuoteStatus: (id) => (formData) => {
      updateQuoteStatus(id, formData)(dispatch);
    },
    getPdf: (id) => {
      getPdfFileForQuote(id)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuotePreView);



// WEBPACK FOOTER //
// ./src/containers/QuotePreView/index.js